import { CCol, CRow } from '@coreui/react'
import InfoIcon from '@mui/icons-material/Info'
import _ from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import CarbonEmissionCard from '../CarbonEmissionCard/CarbonEmissionCard'
import styles from './carbonEmissionComponent.module.scss'

const CarbonEmissionComponent = ({ account }) => {
  const { t } = useTranslation()

  const isActive = _.get(account, 'environmentalData.isCarbonActive', false)
  if (!isActive) return <div>{t('reports.carbonEmissions.disabled')}</div>

  // Filter out years with no carbon factor data and take only the 2 most recent years
  const yearlyEnvironmentalData = (account?.environmentalData?.data || [])
    .filter(({ carbonEmittedPerUnit }) => {
      // Only include years that have valid carbon factor data
      const carbonFactor = _.toNumber(carbonEmittedPerUnit)
      return carbonFactor && carbonFactor > 0
    })
    .sort((dataA, dataB) => {
      const momentYearA = moment(dataA.year, 'YYYY')
      const momentyearB = moment(dataB.year, 'YYYY')
      return momentyearB.diff(momentYearA)
    })
    .slice(0, 2) // Take only the 2 most recent years with data

  if (!yearlyEnvironmentalData.length) return <div>{t('reports.carbonEmissions.noData')}</div>

  // If no years have valid data, show current year card
  const emissionCards = yearlyEnvironmentalData.map(
    ({ year, units, carbonEmittedPerUnit, net }) => (
      <CCol key={year} md={6}>
        <CarbonEmissionCard
          emissionStats={{
            year: _.toNumber(year),
            units,
            carbonEmittedPerUnit,
            net,
          }}
        />
      </CCol>
    ),
  )

  return (
    <>
      <div className={styles.titleStyle}>{t('reports.carbonEmissions.subtitle')}</div>
      <CRow>{emissionCards}</CRow>
      <div className={styles.noteStyle}>
        <InfoIcon sx={{ fontSize: '1.125rem' }} />
        <div>{t('reports.carbonEmissions.unit')}</div>
      </div>
    </>
  )
}

CarbonEmissionComponent.defaultProps = {
  account: {},
}

CarbonEmissionComponent.propTypes = {
  account: PropTypes.object,
}
export default CarbonEmissionComponent
